import { z } from 'zod';

import { EmailSchema } from '../../password';

/**
 * `PATCH /auth/email` — the "wrong address?" door on the verify-email step.
 *
 * Only an **unverified** account may take it (`email_change_not_allowed`
 * otherwise): it exists to recover from a typo at sign-up without support,
 * not to change a proven address — that is a different feature with its own
 * re-verification (P30 decision 11). The api re-issues a code to the new
 * address and answers the verification state.
 */
export const ChangeEmailSchema = z.object({ email: EmailSchema }).strict();

export type ChangeEmailRequest = z.infer<typeof ChangeEmailSchema>;
